import PhotoSwipe from "/libraries/photoswipe/photoswipe.esm.js";
import PhotoSwipeLightbox from "/libraries/photoswipe/photoswipe-lightbox.esm.js";

(function ($, Drupal, PhotoSwipe, PhotoSwipeLightbox) {
  'use strict';

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };

  var escapeHtml = function(string) {
    return String(string).replace(/[&<>"'`=\/]/g, function (s) {
      return entityMap[s];
    });
  }

  Drupal.behaviors.imageModal = {
    attach: function (context) {
      $('.node-book-page-full img, .node-book-page-full-protected img', context).each(function () {
        var $image_element = $(this);
        $image_element.wrap(
          '<div class="pswp-gallery">' +
          '<a href="' + escapeHtml($image_element.attr('src')) + '" ' +
          'data-pswp-width="' + escapeHtml($image_element.attr('width')) + '" ' +
          'data-pswp-height="' + escapeHtml($image_element.attr('height')) + '" ' +
          'target="_blank">' +
          '</a>' +
          '</div>'
        );
      });

      var lightbox = new PhotoSwipeLightbox({
        gallery: '.pswp-gallery a',
        pswpModule: PhotoSwipe
      });

      lightbox.init();
    }
  };

})(jQuery, Drupal, PhotoSwipe, PhotoSwipeLightbox);
